<template>
    <div class="g-content g-autofixheight account">
        <!-- 确认删除弹窗[[ -->
        <div class="g-popup del-account-popup" v-show="showDelPop">
            <div class="popup-con">
                <div class="popup-close" @click="cancle"><i class="ico ico-close"></i></div>
                <h5 class="popup-title">删除账号</h5>
                <div class="del-account-popup-con">
                    <p class="del-account-whether">是否删除该账号？</p>
                    <div class="del-account">
                        <div class="del-account-icon">
                            <img :src="curDelAccount.accountHeader" width="25" height="25" />
                        </div>
                        <div class="del-account-name f-hide-col-1">{{curDelAccount.accountName}}</div>
                    </div>
                </div>
                <div class="g-bottom-btn">
                    <a href="javascript:;" class="button popup-btn-quit" @click="publish">删除</a>
                    <a href="javascript:;" class="button popup-btn-cancel" @click="cancle">取消</a>
                </div>
            </div>
        </div>
        <!-- 确认删除弹窗]] -->
        <!-- 第三方弹窗[[ -->
        <bind-media ref="mediaRef" @bindResult="getMediaUserAccount"></bind-media>
        <!-- 第三方弹窗]] -->
        <!-- 选项卡 -->
        <div class="g-tab">
            <a href="javascript:;" v-for="(item,index) in tabList" :key="index" @click="changeTab(index)">
                <div class="g-tab-item" :class="{'g-tab-item-active': index == curTab}">{{item}}</div>
            </a>
        </div>
        <div class="content-contain-tabs content-contain-tab1" v-show="curTab == 0">
            <div class="media-list-contain">
                <div class="media-list" v-for="(item,index) in userAccount" :key="index">
                    <div class="media-title f-clearfix">
                        <img class="media-logo" :src="item.logo" />
                        <div class="media-intro">
                            <div class="media-intro-title" :class="{'media-intro-title-only': item.enName != 'om'}">{{item.name}}</div>
                            <!-- <div class="media-intro-title">企鹅媒体平台</div> -->
                            <div class="media-intro-text f-hide-col-1" v-show="item.enName == 'om'">腾讯新闻、天天快报、QQ浏览器、QQ空间</div>
                        </div>
                        <!--
                            点击进入当前媒体账号登录
                        -->
                        <span class="account-add f-fr" @click="BindMediaIframe(item)" v-if="item.enName != 'weibo'"></span>
                        <span class="account-num f-fr">{{item.account.length}}个账号</span>
                        <div class="expire-account-text f-fr" v-show="getExpireCount(item.account)>0">
                            <span class="expire-icon f-inlineblock-middle"></span>
                            <p class="text-con f-inlineblock-top"><span class="text-num" v-text="getExpireCount(item.account)"></span>个账号授权已失效</p>
                        </div>
                    </div>
                    <ul class="media-account-detail">

                        <li class="media-account-item" v-for="(accountItem,index2) in item.account" :key="index2">

                            <div class="expire-account-tip">
                                <img class="media-account-img" :src="accountItem.accountHeader" />
                                <div class="expire-icon" v-if="accountItem.expire == 1"></div>
                            </div>

                            <!-- <div class="expire-account-tip">
                                <img class="media-account-img" :src="accountItem.accountHeader"/>
                                <div class="expire-icon" v-if="accountItem.expire == 1"></div>
            				</div>
                            <div class="expire-account-tip" v-show="accountItem.expire == 1">
                                <div class="expire-icon"></div>
                                <div class="expire-account-text">授权已失效</div>
                            </div> -->
                            <span class="media-account-name f-hide-col-1">{{accountItem.accountName}}</span>
                            <!-- 
                                过期失效账号hover
                            -->
                            <div class="media-del-show media-bind-show" v-show="!noDelMedia.includes(item.enName)"
                                v-if="accountItem.expire == 1">
                                <div class="triangle"></div>
                                <div class="delete-text">
                                    <span class="account-bind" @click="BindMediaIframe(item)" v-if="item.enName != 'weibo'">重新绑定</span>
                                    <span class="account-delete" @click="delAccount(accountItem)">删除</span>
                                </div>
                            </div>
                            <!-- 
                                正常账号hover
                            -->
                            <div class="media-del-show" v-show="!noDelMedia.includes(item.enName)" v-else>
                                <div class="triangle"></div>
                                <div class="delete-text">
                                    <span class="account-delete" @click="delAccount(accountItem)">删除</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="bind-channel-contain">
                <div class="bind-channel-title">绑定更多渠道</div>
                <ul class="channel-list">
                    <li class="channel-item" v-for="(item,index) in mediaList" :key="index" v-if="item.enName != 'weibo'">
                        <img class="channel-logo" :src="item.logo" :alt="item.name" />
                        <div class="channel-name f-hide-col-1">{{item.name}}</div>
                        <!--
                            交互说明：光标进入有hover效果；
                            点击进入第三方媒体账号登录
                        -->
                        <div class="account-add" @click="BindMediaIframe(item)"></div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="content-contain-tabs content-contain-tab2" v-show="curTab == 1">
            <div class="account-public-tips">公用账号仅供订单投稿模式下使用，无需绑定个人渠道账号，即可一键内容发布</div>
            <div class="media-list-contain">
                <div class="media-list" v-for="(item,index) in pubAccount" :key="index">
                    <div class="media-title f-clearfix">
                        <img class="media-logo" :src="item.logo" />
                        <div class="media-intro f-clearfix">
                            <div class="media-intro-title" :class="{'media-intro-title-only': item.enName != 'om'}">{{item.name}}<span
                                    class="account-num">{{item.account.length}}个账号</span></div>
                            <div class="media-intro-text f-hide-col-1" v-show="item.enName == 'om'">腾讯新闻、天天快报、QQ浏览器、QQ空间</div>
                        </div>
                        <div class="expire-account-text f-fr" v-show="getExpireCount(item.account)>0">
                            <span class="expire-icon f-inlineblock-middle"></span>
                            <p class="text-con f-inlineblock-top"><span class="text-num" v-text="getExpireCount(item.account)"></span>个账号授权已失效</p>
                        </div>
                    </div>
                    <ul class="media-account-detail">
                        <li class="media-account-item" v-for="(item,index2) in item.account" :key="index2">
                            <img class="media-account-img" :src="item.accountHeader" />
                            <div class="expire-icon" v-if="item.expire == 1" style="position: absolute;top: -3px;left: 15px;"></div>
                            <span class="media-account-name f-hide-col-1">{{item.accountName}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/manage/account.scss';
</style>
<script>
import {
    MediaList, MediaUserAccountGroup, MediaAuth, MediaPubAccountGroup, DelUserMediaAccount, vqqBind, WXbind, kandianBind
} from 'Services/getData';

import bindMedia from 'Components/v4/pop/bind_media.vue';
export default {
    data() {
        return {
            tabList: ['我的账号', '公用账号'],
            curTab: 0,
            userAccount: [],
            pubAccount: [],
            mediaList: [],
            showDelPop: false,
            curDelAccount: '',
            params: {
                type: 2
            },
            mediaChangeNum: 0,
            interval: '',
            noDelMedia: ['wx', 'kandian', 'qq']
        }
    },
    components: {
        bindMedia
    },
    mounted() {
        this.getMediaUserAccount();
        this.getMediaPubAccount();
        this.getMediaList();
        this.$nextTick(() => {
            this.mediaChange();
        })
    },
    watch: {
        mediaChangeNum(val) {
            this.getMediaUserAccount();
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        mediaChange() {
            this.interval = setInterval(() => {
                if (this.$common.getSessionStore('mediaChange') == this.mediaChangeNum) {
                    return;
                } else {
                    this.mediaChangeNum = this.$common.getSessionStore('mediaChange');
                }
            }, 1000)
        },
        getExpireCount(account) {
            let num = 0;
            account.forEach((v, k) => {
                if (v.expire == 1) {
                    num++;
                }
            })
            return num;
        },
        async publish() {
            let params = {};
            params.id = this.curDelAccount.id;
            // let res = DelUserMediaAccount(params);
            this.$http({
                method: 'delete',
                type: 'delete',
                url: DelUserMediaAccount,
                data: params
            }).then((response) => {
                this.showDelPop = false;
                if (response.data.code == 0) {
                    this.$alert('删除成功');
                    this.getMediaUserAccount();
                }
            });
        },
        cancle() {
            this.showDelPop = false;
        },
        changeTab(index) {
            this.curTab = index;
        },
        delAccount(item) {
            this.showDelPop = true;
            this.curDelAccount = item;
        },
        getMediaUserAccount() {
            MediaUserAccountGroup().then((res) => {
                this.userAccount = res.data.data;
                // console.log(this.userAccount)
            })
        },
        getMediaPubAccount() {
            MediaPubAccountGroup().then((res) => {
                this.pubAccount = res.data.data;
            })
        },
        async getMediaList() {
            let res = await MediaList(this.params);
            if (res.data.code == 0) {
                this.mediaList = res.data.data;
            }
        },
        async BindMediaIframe(media) {
            console.log(media)
            this.$refs.mediaRef.BindMediaIframe(media);
        }
    }
}
</script>